import { render, staticRenderFns } from "./OwnershipRequestPage.vue?vue&type=template&id=4005f4ef"
import script from "./OwnershipRequestPage.vue?vue&type=script&lang=js"
export * from "./OwnershipRequestPage.vue?vue&type=script&lang=js"
import style0 from "./OwnershipRequestPage.vue?vue&type=style&index=0&id=4005f4ef&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4005f4ef')) {
      api.createRecord('4005f4ef', component.options)
    } else {
      api.reload('4005f4ef', component.options)
    }
    module.hot.accept("./OwnershipRequestPage.vue?vue&type=template&id=4005f4ef", function () {
      api.rerender('4005f4ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/OwnershipRequestPage.vue"
export default component.exports